import { object, string } from 'yup';
import { ValidationErrorMessages } from './types/validation';
export const loginFormValidation = object({
    email: string()
        .required(ValidationErrorMessages.REQUIRED)
        .email(ValidationErrorMessages.EMAIL),
    password: string().required(ValidationErrorMessages.REQUIRED),
});
//# sourceMappingURL=loginFormValidation.js.map